import React, { useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";

const FIELDS = [
  ["supplier_name", "Nama supplier"],
  ["buyer_name", "Nama buyer tujuan"],
  ["gold_amount", "Jumlah gold dikirim"],
  ["character_id", "ID karakter"],
  ["server", "Server"],
];
const inCls = "w-full bg-[#101114] border border-[#35353B] focus:border-[#D4AF37] text-[#F5F3ED] rounded-sm px-2.5 py-1.5 text-sm outline-none transition-colors";

export const blankNote = (peer) => ({
  supplier_name: peer.role === "supplier" ? peer.name : "", buyer_name: peer.role === "buyer" ? peer.name : "",
  gold_amount: "", character_id: "", server: "", status: "pending", note: "",
});

export default function NoteForm({ peer, initial, onSaved, onCancel }) {
  const [f, setF] = useState(() => ({ ...blankNote(peer), ...(initial || {}) }));
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    const body = Object.fromEntries(["supplier_name", "buyer_name", "gold_amount", "character_id", "server", "status", "note"].map((k) => [k, f[k] ?? ""]));
    try {
      const r = initial?.id ? await api.patch(`/internal-notes/${initial.id}`, body) : await api.post("/internal-notes", { ...body, peer_id: peer.id });
      toast.success(initial?.id ? "Catatan diperbarui" : "Catatan disimpan");
      onSaved(r.data);
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Gagal menyimpan catatan. Periksa isian.");
    } finally { setSaving(false); }
  };

  return (
    <form data-testid="note-form" onSubmit={save} className="space-y-2 bg-[#191A1F] border border-[#D4AF37]/40 rounded-md p-3">
      {FIELDS.map(([k, label]) => (
        <label key={k} className="block">
          <span className="text-[10px] uppercase tracking-widest text-[#A8A8AD]">{label}</span>
          <input data-testid={`note-${k}-input`} maxLength={100} value={f[k] || ""} onChange={set(k)} className={inCls} />
        </label>
      ))}
      <label className="block">
        <span className="text-[10px] uppercase tracking-widest text-[#A8A8AD]">Status pengiriman</span>
        <select data-testid="note-status-select" value={f.status} onChange={set("status")} className={inCls}>
          <option value="pending">Belum dikirim</option>
          <option value="done">Selesai</option>
        </select>
      </label>
      <label className="block">
        <span className="text-[10px] uppercase tracking-widest text-[#A8A8AD]">Catatan tambahan</span>
        <textarea data-testid="note-note-input" rows={3} maxLength={2000} value={f.note || ""} onChange={set("note")} className={`${inCls} resize-none`} />
      </label>
      <div className="flex gap-2 pt-1">
        <button data-testid="note-save-btn" type="submit" disabled={saving} className="flex-1 bg-[#D4AF37] text-[#101114] hover:bg-[#F2D98D] disabled:opacity-50 font-bold rounded-sm py-1.5 text-sm transition-colors">{saving ? "Menyimpan…" : "Simpan"}</button>
        <button data-testid="note-cancel-btn" type="button" onClick={onCancel} className="px-3 border border-[#35353B] text-[#A8A8AD] hover:text-[#F5F3ED] rounded-sm text-sm transition-colors">Batal</button>
      </div>
    </form>
  );
}
